import ArrowIcon from "../../../../Components/Common/svg/reports/arrowicon";
import MessagesIcon from "../../../../Components/Common/svg/reports/messagesicon";
import StarIcon from "../../../../Components/Common/svg/reports/staricon";
import ShoppingIcon from "../../../../Components/Common/svg/shoppingicon";
import StartIcon from "../../../../Components/Common/svg/starticon";

export const StatsProductShowConfig = (productStats) => [
  {
    title: "إجمالي الطلبات",
    count: productStats.total_orders,
    color: "#FFCC03",
    icon: <ShoppingIcon />,
    bgIcon: "#E6F3EF",
  },
  {
    title: "معدل التحويل  ",

    count:`${productStats.conversion_rate} %`,
    color: "#1DBF73",
    icon: <ArrowIcon />,
    bgIcon: "#F0FDF9",
  },

  {
    title: "التقييم",
    count: productStats.total_rating,
    color: "#FFCC00",
    icon: <StarIcon />,
    bgIcon: "#FFFCE9",
  },
  {
    title: "عدد المراجعات ",
    count: productStats.total_reviews,
    color: "#0F2B42",
    icon: <MessagesIcon />,
    bgIcon: "#E7EAEC",
  },
];
